import { Doughnut } from 'react-chartjs-2';
import { useState, useEffect } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import styles from './campaignAnalytics.module.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const CampaignAnalytics = ({ campaignDetails }) => {
  const analytics = campaignDetails?.analytics || {};

  const [showChart, setShowChart] = useState(false);

  const pieStatusData = {
    labels: ['Sent', 'Delivered', 'Read', 'Failed'],
    datasets: [
      {
        label: 'Conversations',
        data: [
          analytics.sent || 0,
          analytics.delivered || 0,
          analytics.read || 0,
          analytics.failed || 0,
        ],
        backgroundColor: ['grey', '#FFE66D', '#C4E0A5', '#570000'],
        borderColor: ['transparent'],
        borderWidth: 2,
        hoverOffset: 1,
      },
    ],
  };

  const pieOptions = {
    maintainAspectRatio: false, // 🔥 important for size control
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  useEffect(() => {
    if (analytics.sent || analytics.delivered || analytics.read || analytics.failed) {
      setShowChart(true);
    } else {
      setShowChart(false);
    }
  }, [campaignDetails]);

  return (
    <>
      {showChart ? (
        <div className="w-full flex flex-column">
          {/* Title (optional, same as your other component) */}
          <div className="flex w-full justify-content-center mb-2 md:mb-5">Campaign Statistics</div>

          <div className="w-12 flex justify-content-center flex-wrap flex-column md:flex-row">
            <div className="w-12 md:w-8 lg:w-10 xl:w-10 flex flex-wrap md:flex-nowrap justify-content-center md:justify-content-between gap-2">
              {/* Doughnut Chart */}
              <div className="flex-grow-1 flex justify-content-center">
                <div style={{ width: '200px', height: '200px' }}>
                  <Doughnut data={pieStatusData} options={pieOptions} />
                </div>
              </div>

              {/* Legend Section */}
              <div className="flex-grow-1 flex justify-content-center">
                <div className={`px-4 py-2 ${styles['pie-data-container']}`}>
                  {pieStatusData.labels.map((label, index) => (
                    <div className="pb-2 flex align-items-center gap-2" key={index}>
                      <div
                        style={{
                          width: '20px',
                          height: '15px',
                          borderRadius: '50%',
                          backgroundColor: pieStatusData.datasets[0].backgroundColor[index],
                        }}
                      ></div>

                      <div className="w-full flex gap-2 justify-content-between">
                        <div>{label}</div>
                        <span>: {pieStatusData.datasets[0].data[index]}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="py-3 flex justify-content-center">{/* No data */}</div>
      )}
    </>
  );
};

export default CampaignAnalytics;
